import {Race} from './Race'
import {useEffect} from 'react'
import {useAPIData} from '../context/hooks/useAPIData'
import {getOldRaces} from '../context/actions/userActions'


export const OldRaces = (props) => {
    const data = useAPIData()
    let races = data.oldRaces
    const racesNames = [ ...new Set(races && races.map(race => race.code))]
    useEffect(() => {
        if(data.oldRaces.length > 0) {
            return
        }
        getOldRaces(data.dispatch)
    }, [])

    return (
        <main className={props.inactive ? 'main-inactive' : ''}>
            {
                !data.loadingOld && races && races.length > 0 && racesNames.map((name, index) => {
                    const sameCode = races.filter(race => race.code === name)

                    return (<Race key={index} inactive={props.inactive} type={sameCode.length > 1 ? 'double' : 'single'} races={sameCode}/>)
                })
            }
        </main>
    )
}